export enum StorageDestinationTypeV2 {
  RECOMMENDED_WAREHOUSE = "RECOMMENDED_WAREHOUSE",
  SPECIFIC_WAREHOUSE = "SPECIFIC_WAREHOUSE",
}
